export default "__VITE_ASSET__Bvf_nrNy__"